import { render, staticRenderFns } from "./choose_button.vue?vue&type=template&id=6859b59c&scoped=true"
import script from "./choose_button.vue?vue&type=script&lang=js"
export * from "./choose_button.vue?vue&type=script&lang=js"
import style0 from "./choose_button.vue?vue&type=style&index=0&id=6859b59c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859b59c",
  null
  
)

export default component.exports